import {ChipProps} from "@mui/material"

export enum EndpointStatus {
    STARTING = "STARTING",
    STARTED = "STARTED",
    STOPPED = "STOPPED",
    DELETED = "DELETED",
    ERROR = "ERROR",
}

export function resolveEndpointStatusLabel(status: EndpointStatus): string {
    switch (status) {
        case EndpointStatus.STARTING:
            return "Starting"
        case EndpointStatus.STARTED:
            return "Online"
        case EndpointStatus.STOPPED:
            return "Offline"
        case EndpointStatus.DELETED:
            return "Deleted"
        case EndpointStatus.ERROR:
            return "Error"
    }
}

export function resolveEndpointStatusColor(status: EndpointStatus): ChipProps["color"] {
    switch (status) {
        case EndpointStatus.STARTED:
            return "success"
        case EndpointStatus.STARTING:
            return "warning"
        case EndpointStatus.ERROR:
            return "error"
        case EndpointStatus.STOPPED:
        case EndpointStatus.DELETED:
            return "default"
    }
}
